import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {DataService} from './services/data.service';
import {AuthService} from './services/auth.service';
import {ConfigService} from './services/config.service';
import {AppStateService} from './services/app-state.service';
import {AppRoutingModule} from './app-routing.module';
import {NoContentComponent} from './no-content/no-content.component';

import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from './services/auth.interceptor';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getAuth, provideAuth} from '@angular/fire/auth';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {getFunctions, provideFunctions} from '@angular/fire/functions';
import {getStorage, provideStorage} from '@angular/fire/storage';
import {PrivateModule} from './private';
import {environment} from '../environments/environment';
import {MAT_MOMENT_DATE_FORMATS, MatMomentDateModule, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import {registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from './shared/shared.module';
import {RouterModule} from '@angular/router';



export function initializeFirebase() {
    return initializeApp(environment.firebase);
}

export function initializeAuth() {
    return getAuth();
}

export function initializeFirestore() {
    return getFirestore();
}

export function initializeFunctions() {
    return getFunctions();
}

export function initializeStorage() {
    return getStorage();
}

registerLocaleData(localeIt, 'it');

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        MatMomentDateModule,
        HttpClientModule,
        PrivateModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        RouterModule,
        NoContentComponent
    ],
    providers: [
        AuthService,
        ConfigService,
        DataService,
        AppStateService,
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
        {provide: MAT_DATE_LOCALE, useValue: 'en-US'},
        {provide: LOCALE_ID, useValue: 'it-IT'},
        provideFirebaseApp(initializeFirebase),
        provideAuth(initializeAuth),
        provideFirestore(initializeFirestore),
        provideFunctions(initializeFunctions),
        provideStorage(initializeStorage)
    ]
})
export class AppModule {
    constructor(
        dataService: DataService) { // this is handy for pre-loading this service
    }
}